import React from "react";
import Tag from "../../../SupportingDocuments/Tag";
import { getStatusVariantAndColor } from "../../shared/utils/moduleHelpers";

const StatusBadge = ({ status }) => {
    if (!status) return null;
    
    const statusLower = status?.toLowerCase() || "";
    let label = status?.toUpperCase();

    if (statusLower === "fail" || statusLower === "failed") {
        label = "FAILED";
    } else if (statusLower === "eligible") {
        label = "ELIGIBLE";
    } else if (statusLower === "not eligible" || statusLower === "noteligible" || statusLower === "not_eligible") {
        label = "NOT ELIGIBLE";
    } else if (statusLower === "pass" || statusLower === "passed") {
        label = "PASSED";
    } else if (statusLower === "exempt") {
        label = "EXEMPT";
    } else if (statusLower === "enrolled") {
        label = "ENROLLED";
    } else if (statusLower === "deregister") {
        label = "NOT ELIGIBLE";
    } else if (statusLower === "inactive") {
        label = "UPCOMING";
    }

    const { variant, customColor } = getStatusVariantAndColor(status);
    const tagStyle = {
      
        textAlign: "center",
        ...(customColor && { backgroundColor: customColor })
    };

    return <Tag variant={variant} style={tagStyle}>{label}</Tag>;
};

export default StatusBadge;

